import React from 'react';

import { FlexCol } from '../FlexCol';
import { LocationInfoRow } from './LocationInfoRow';
import { PropertyInfoRow } from './PropertyInfoRow';

export const LocationSectionForm = ({ data = {}, advanced = false, onChangeItem = () => {} }) => {
  const list = data.filter((item) => (advanced ? item : !item.advanced));
  return (
    <FlexCol className="w-full">
      <FlexCol className="lg:flex-row">
        <FlexCol className="w-full">
          {list.slice(0, Math.ceil(list.length / 2)).map((section, index) => {
            return <LocationInfoRow key={index} className="w-full" section={section} onChangeItem={onChangeItem} />;
          })}
        </FlexCol>
        <FlexCol className="w-full">
          {list.slice(Math.ceil(list.length / 2), list.length).map((section, index) => {
            if (section.label === 'Street #') {
              return <PropertyInfoRow key={index} className="w-full" section={section} onChangeItem={onChangeItem} />;
            }
            return <LocationInfoRow key={index} className="w-full" section={section} onChangeItem={onChangeItem} />;
          })}
        </FlexCol>
      </FlexCol>
    </FlexCol>
  );
};
